import { render, staticRenderFns } from "./goodsIncome.vue?vue&type=template&id=6d67905e&"
import script from "./goodsIncome.vue?vue&type=script&lang=js&"
export * from "./goodsIncome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports